import { buildPermission } from "portal/utils/auth";
import { JobDetailsPage } from "./JobDetailsPage";
import { JobList } from "./JobList";
import { NewJobsWizard } from "./new-jobs/NewJobsWizard";
import { OrchestratePage } from "./orchestrate/OrchestratePage";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { useRoutes } from "react-router-dom";
import { withAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import React, { FunctionComponent } from "react";

const _Jobs: FunctionComponent = () => {
  return useRoutes([
    { path: "/", element: <JobList /> },
    { path: "/create", element: <NewJobsWizard /> },
    { path: "/:jobId", element: <JobDetailsPage /> },
    { path: "/:jobId/orchestrate", element: <OrchestratePage /> },
  ]);
};

export const Jobs = withAuthorizationRequired(
  {
    or: [
      buildPermission(
        PermissionAction.read,
        PermissionResource.autotractor_jobs,
        PermissionDomain.customer
      ),
      buildPermission(
        PermissionAction.read,
        PermissionResource.autotractor_jobs,
        PermissionDomain.all
      ),
    ],
  },
  _Jobs
);
